(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glr-bioethanol-cta"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('glr-biocta-rail')) {
  class GlrBioctaRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-glr-biocta-track]');
      if (!this.track || this.ready) return;
      // Init erst bei Sichtbarkeit: kein Scroll-Listener und kein Layout-Read fuer eine
      // Section, die der Besucher nie erreicht.
      if (!('IntersectionObserver' in window)) { this.init(); return; }
      this.io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { this.io.disconnect(); this.init(); }
      }, { rootMargin: '400px' });
      this.io.observe(this);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.mq && this.onMq) {
        if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
        else if (this.mq.removeListener) this.mq.removeListener(this.onMq);
      }
    }
    init() {
      this.ready = true;
      this.cards = Array.prototype.slice.call(this.track.children);
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-glr-dot]'));
      this.active = 0;
      // Der Slider ist auf allen Breiten aktiv (CSS greift, sobald die Rail existiert).
      // Eine immer-wahre Media-Query haelt Fokus/Pfeiltasten/Punkte konsistent — alle
      // this.mq.matches-Bedingungen unten bleiben dadurch unveraendert nutzbar.
      this.mq = window.matchMedia('(min-width:0px)');
      this.onMq = () => this.apply();
      if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
      else if (this.mq.addListener) this.mq.addListener(this.onMq);
      this.track.addEventListener('scroll', () => {
        if (!this.mq.matches || this.lock != null) return;
        window.cancelAnimationFrame(this.raf);
        this.raf = window.requestAnimationFrame(() => this.sync(this.nearest()));
      }, { passive: true });
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-glr-goto]');
        if (!btn || !this.contains(btn)) return;
        this.goTo(parseInt(btn.getAttribute('data-glr-goto'), 10));
      });
      this.track.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        this.goTo(this.active + (e.key === 'ArrowRight' ? 1 : -1));
      });
      this.apply();
    }
    apply() {
      const on = this.mq.matches;
      this.toggleAttribute('data-glr-ready', on);
      if (on) {
        const label = this.getAttribute('data-a11y-label') || '';
        this.track.setAttribute('tabindex', '0');
        this.track.setAttribute('role', 'group');
        this.track.setAttribute('aria-roledescription', label);
        this.track.setAttribute('aria-label', label);
        this.sync(this.nearest());
      } else {
        this.track.removeAttribute('tabindex');
        this.track.removeAttribute('role');
        this.track.removeAttribute('aria-roledescription');
        this.track.removeAttribute('aria-label');
        this.sync(0);
      }
    }
    reduced() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
    // Zielposition je Karte. Karte 0 liegt um das Bleed-Padding eingerueckt im Track — dank
    // scroll-padding rastet sie aber bei scrollLeft 0. Deshalb wird alles auf Karte 0 bezogen.
    targetFor(i) {
      if (!this.cards.length) return 0;
      return this.cards[i].offsetLeft - this.cards[0].offsetLeft;
    }
    nearest() {
      const x = this.track.scrollLeft;
      let best = 0, bd = Infinity;
      this.cards.forEach((c, i) => {
        const d = Math.abs(this.targetFor(i) - x);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    goTo(i) {
      if (!this.cards.length || !this.mq.matches) return;
      const idx = Math.max(0, Math.min(this.cards.length - 1, i));
      this.lock = idx;
      window.clearTimeout(this.lockT);
      this.lockT = window.setTimeout(() => { this.lock = null; }, 650);
      this.track.scrollTo({ left: this.targetFor(idx), behavior: this.reduced() ? 'auto' : 'smooth' });
      this.sync(idx);
    }
    sync(i) {
      this.active = i;
      this.dots.forEach((d, n) => { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
  }
  customElements.define('glr-biocta-rail', GlrBioctaRail);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glr-community-reels"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('glr-community-reels')) {
  /* Wie viele Clips gleichzeitig gepuffert bleiben duerfen. Ohne Deckel haelt der Browser jedes
     einmal geladene Video im Speicher — bei vielen Reels laeuft das auf Mobilgeraeten voll und
     genau die aktive Karte ruckelt dann. Drei Karten sind immer geschuetzt (aktiv + Nachbarn),
     der vierte Platz ist die Reserve zum Verdraengen. */
  const WARM_MAX = 4;
  const COARSE = !!(window.matchMedia && window.matchMedia('(hover: none)').matches);
  class GlrCommunityReels extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-glr-track]');
      if (!this.track || this.ready) return;
      if (!('IntersectionObserver' in window)) { this.init(); return; }
      this.io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { this.io.disconnect(); this.init(); }
      }, { rootMargin: '600px' });
      this.io.observe(this);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.mio) this.mio.disconnect();
      if (this.ro) this.ro.disconnect();
      if (this.mql && this._mqlHandler) {
        if (this.mql.removeEventListener) this.mql.removeEventListener('change', this._mqlHandler);
        else if (this.mql.removeListener) this.mql.removeListener(this._mqlHandler);
      }
    }
    init() {
      this.ready = true;
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-glr-card]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-glr-dot]'));
      this.active = 0;
      this.track.addEventListener('scroll', () => {
        if (this.lock != null) return;
        window.cancelAnimationFrame(this.raf);
        this.raf = window.requestAnimationFrame(() => this.sync(this.nearest()));
      }, { passive: true });
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-glr-goto]');
        if (!btn || !this.contains(btn)) return;
        this.goTo(parseInt(btn.getAttribute('data-glr-goto'), 10));
      });
      // Filter-Pills (optional): schalten Kategorien um. Eigener Selektor, damit sie NICHT den
      // goto-Handler des Karussells ausloesen. aria-pressed exklusiv, dann Karten filtern.
      this.pills = Array.prototype.slice.call(this.querySelectorAll('[data-glr-filter]'));
      if (this.pills.length) {
        this.addEventListener('click', (e) => {
          const p = e.target.closest('[data-glr-filter]');
          if (!p || !this.contains(p)) return;
          this.pills.forEach((x) => x.setAttribute('aria-pressed', x === p ? 'true' : 'false'));
          this.filterBy(p.getAttribute('data-glr-filter'));
        });
      }
      this.track.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        this.goTo(this.active + (e.key === 'ArrowRight' ? 1 : -1));
      });
      this.measure();
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => {
          window.cancelAnimationFrame(this.mraf);
          this.mraf = window.requestAnimationFrame(() => this.measure());
        });
        this.ro.observe(this.track);
      }
      this.sync(0);
      this.initMedia();
    }
    // Passt die Rail komplett in den Scrollport, gibt es nichts zu bedienen — dann verschwinden
    // die Punkte, statt wirkungslos dazustehen.
    measure() {
      this.toggleAttribute('data-glr-static', this.track.scrollWidth <= this.track.clientWidth + 1);
    }
    pad() {
      return parseFloat(window.getComputedStyle(this.track).paddingInlineStart) || 0;
    }
    // Loop-Clips: abgespielt wird erst, wenn die Karte wirklich sichtbar ist. Der IO clippt die
    // Ziel-Rects an den Scroll-Containern der Vorfahren — horizontal weggescrollte Karten zaehlen
    // also nicht als sichtbar und pausieren. GELADEN wird dagegen deutlich frueher (siehe warm()),
    // sonst starrt man beim Aufscrollen erst auf das Poster.
    initMedia() {
      this.mql = window.matchMedia('(max-width:749px)');
      this.pickMedia();
      if (!this.cardMedia.some(Boolean)) return;
      this.captureClipSrc();
      this.warmOrder = [];
      this.mediaReady = true;

      // Viewport-Wechsel (Drehen/Resize): das nun sichtbare Element uebernehmen, das andere kalt
      // stellen — so bleibt es bei genau einem geladenen Video je Viewport.
      this._mqlHandler = () => this.rebuildMedia();
      if (this.mql.addEventListener) this.mql.addEventListener('change', this._mqlHandler);
      else if (this.mql.addListener) this.mql.addListener(this._mqlHandler);

      // Reduzierte Bewegung: Poster bleibt stehen. Auch das preload='metadata' aus dem Markup wird
      // zurueckgenommen — kein Byte fuer etwas, das nie laufen wird.
      if (this.reduced()) { this.cardMedia.forEach((m) => this.cool(m)); return; }

      this.wireReady();

      // Vorabladen bei Annaeherung statt erst bei Sichtbarkeit: Zeigefinger/Fokus auf einer Karte
      // ist der frueheste ehrliche Hinweis, dass sie gleich dran ist.
      this.cards.forEach((card, i) => {
        const prime = () => this.warm(i);
        card.addEventListener('mouseenter', prime);
        card.addEventListener('touchstart', prime, { passive: true });
        card.addEventListener('focusin', prime);
      });

      this.warmAround(this.active);
      this.observeMedia();
    }
    // Je Karte das zum Viewport passende Medium waehlen. Ohne Mobil-Variante gibt es nur ein Element
    // — dann greift es unveraendert. Mit Mobil-Variante entscheidet data-glr-viewport (dt/m).
    pickMedia() {
      const want = (this.mql && this.mql.matches) ? 'm' : 'dt';
      this.cardMedia = this.cards.map((c) => {
        const list = Array.prototype.slice.call(c.querySelectorAll('[data-glr-clip],[data-glr-embed]'));
        if (!list.length) return null;
        if (list.length === 1) return list[0];
        let match = null;
        list.forEach((el) => { if (el.getAttribute('data-glr-viewport') === want) match = el; });
        return match || list[0];
      });
    }
    // Quell-URLs je Clip einmalig am Element sichern — ueberlebt cool() (entfernt die <source>-Knoten,
    // um Puffer freizugeben) und einen Viewport-Wechsel. warm() baut daraus die Quellen neu auf.
    captureClipSrc() {
      this.clipSrc = this.cardMedia.map((m) => {
        if (!m || m.tagName !== 'VIDEO') return null;
        if (!m._glrSources) {
          m._glrSources = Array.prototype.slice.call(m.querySelectorAll('source')).map((n) => ({ src: n.getAttribute('src'), type: n.getAttribute('type') }));
        }
        return m._glrSources;
      });
    }
    // Erst einblenden, wenn wirklich ein Bild da ist — sonst blitzt beim Umschalten ein leeres
    // Frame ueber dem Poster auf. Nur einmal je Element verdrahten.
    wireReady() {
      this.cardMedia.forEach((m) => {
        if (!m || m.tagName !== 'VIDEO' || m._glrReadyWired) return;
        m._glrReadyWired = true;
        const ready = () => { if (m.readyState >= 2) m.setAttribute('data-glr-ready', ''); };
        m.addEventListener('loadeddata', ready);
        m.addEventListener('canplay', ready);
        m.addEventListener('error', () => m.removeAttribute('data-glr-ready'));
        ready();
      });
    }
    observeMedia() {
      if (!('IntersectionObserver' in window)) { this.cardMedia.forEach((m) => { if (m) this.playMedia(m); }); return; }
      this.mio = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { this.playMedia(e.target); } else { this.pauseMedia(e.target); } });
      }, { threshold: 0.35 });
      this.cardMedia.forEach((m) => { if (m) this.mio.observe(m); });
    }
    // Viewport gewechselt: altes Set kaltstellen, neues Set anwaermen + beobachten.
    rebuildMedia() {
      if (!this.mediaReady) return;
      if (this.mio) { this.mio.disconnect(); this.mio = null; }
      this.cardMedia.forEach((el) => this.coolAny(el));
      this.warmOrder = [];
      this.pickMedia();
      this.captureClipSrc();
      if (this.reduced()) { this.cardMedia.forEach((m) => this.cool(m)); return; }
      this.wireReady();
      this.warmAround(this.active);
      this.observeMedia();
    }
    coolAny(el) {
      if (!el) return;
      if (el.tagName === 'VIDEO') { this.cool(el); return; }
      el.removeAttribute('src');
      el.removeAttribute('data-glr-playing');
    }
    // Aktive Karte + direkte Nachbarn aggressiv laden — in dieser Reihenfolge, damit die aktive
    // Karte bei vollem Cache zuletzt verdraengt wird.
    warmAround(i) { [i - 1, i + 1, i].forEach((n) => this.warm(n)); }
    // Diese drei duerfen nie verdraengt werden.
    keep() { return [this.active - 1, this.active, this.active + 1]; }
    warm(i) {
      if (COARSE) return;
      if (!this.mediaReady || this.reduced()) return;
      const el = this.cardMedia[i];
      if (!el || el.tagName !== 'VIDEO') return;
      const pos = this.warmOrder.indexOf(i);
      if (pos > -1) this.warmOrder.splice(pos, 1);
      this.warmOrder.push(i);
      const sources = this.clipSrc[i] || [];
      if (!el.querySelector('source') && sources.length) {
        sources.forEach((n) => {
          const node = document.createElement('source');
          node.setAttribute('src', n.src);
          if (n.type) node.setAttribute('type', n.type);
          el.appendChild(node);
        });
        el.preload = 'auto';
        el.load();
      } else if (el.preload !== 'auto') {
        el.preload = 'auto';
        el.load();
      }
      this.trim();
    }
    trim() {
      while (this.warmOrder.length > WARM_MAX) {
        const keep = this.keep();
        const at = this.warmOrder.findIndex((n) => keep.indexOf(n) === -1);
        if (at === -1) return; // nur noch Geschuetztes uebrig
        this.cool(this.cardMedia[this.warmOrder.splice(at, 1)[0]]);
      }
    }
    cool(el) {
      if (!el || el.tagName !== 'VIDEO') return;
      if (COARSE) { el.pause(); return; }
      el.removeAttribute('data-glr-ready'); // blendet zurueck aufs Poster, kein Sprung auf Schwarz
      el.pause();
      el.preload = 'none';
      while (el.firstChild) el.removeChild(el.firstChild);
      el.removeAttribute('src');
      el.load();
    }
    playMedia(el) {
      if (el.tagName === 'VIDEO') {
        if (this.reduced()) return;
        this.warm(this.cardMedia.indexOf(el));
        el.muted = true;
        el.playsInline = true;
        el.setAttribute('muted', '');
        const tryPlay = () => { const pr = el.play(); if (pr && pr.catch) pr.catch(() => {}); };
        tryPlay();
        el.addEventListener('loadeddata', tryPlay, { once: true });
        el.addEventListener('canplay', tryPlay, { once: true });
        return;
      }
      if (el.getAttribute('src')) return;
      const type = el.getAttribute('data-glr-embed-type');
      const id = el.getAttribute('data-glr-embed-id');
      if (!id) return;
      el.setAttribute('src', type === 'vimeo'
        ? 'https://player.vimeo.com/video/' + id + '?background=1&autoplay=1&loop=1&muted=1&autopause=0&dnt=1'
        : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&mute=1&loop=1&playlist=' + id + '&controls=0&modestbranding=1&rel=0&playsinline=1&disablekb=1');
      el.setAttribute('data-glr-playing', '');
    }
    pauseMedia(el) {
      if (el.tagName === 'VIDEO' && !el.paused) el.pause();
    }
    reduced() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
    // snap-align:start -> die Karte rastet an der Innenkante des Scrollports (= scroll-padding).
    nearest() {
      const start = this.track.scrollLeft + this.pad();
      let best = 0, bd = Infinity;
      this.cards.forEach((c, i) => {
        if (c.hidden) return;
        const d = Math.abs(c.offsetLeft - start);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    goTo(i) {
      if (!this.cards.length) return;
      let idx = Math.max(0, Math.min(this.cards.length - 1, i));
      // Ausgeblendete Karte angesteuert (z. B. Pfeiltaste auf gefilterter Rail): in Richtung
      // weitersuchen, sonst erste sichtbare Karte nehmen.
      if (this.cards[idx] && this.cards[idx].hidden) {
        const dir = i >= this.active ? 1 : -1;
        let j = idx;
        while (j >= 0 && j < this.cards.length && this.cards[j].hidden) j += dir;
        if (j < 0 || j >= this.cards.length || this.cards[j].hidden) j = this.cards.findIndex((c) => !c.hidden);
        if (j < 0) return;
        idx = j;
      }
      const card = this.cards[idx];
      this.lock = idx;
      window.clearTimeout(this.lockT);
      this.lockT = window.setTimeout(() => { this.lock = null; }, 650);
      this.track.scrollTo({ left: Math.max(0, card.offsetLeft - this.pad()), behavior: this.reduced() ? 'auto' : 'smooth' });
      this.sync(idx);
    }
    sync(i) {
      this.active = i;
      this.cards.forEach((c, n) => { c.toggleAttribute('data-glr-active', n === i); });
      this.dots.forEach((d, n) => { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      // Nachbarn der neuen aktiven Karte anwaermen (initMedia() uebernimmt den ersten Start,
      // deshalb die Guard).
      if (this.mediaReady) this.warmAround(i);
    }
    // Reine Anzeige-Filterung: Karten (und ihre Dots) per hidden ein-/ausblenden. Ausgeblendete
    // Videos werden pausiert und Embeds entladen; der IntersectionObserver haelt sie ohnehin
    // pausiert (display:none => nicht sichtbar). Danach Slider neu vermessen und auf die erste
    // sichtbare Karte snappen.
    filterBy(val) {
      const all = !val || val === '__all__';
      this.cards.forEach((card, n) => {
        let show = all;
        if (!all) {
          const raw = card.getAttribute('data-glr-filter') || '';
          const labels = raw.split(',').map((x) => x.trim()).filter(Boolean);
          show = labels.indexOf(val) !== -1;
        }
        card.hidden = !show;
        if (this.dots && this.dots[n]) this.dots[n].hidden = !show;
        if (!show) {
          Array.prototype.forEach.call(card.querySelectorAll('video'), (v) => { if (!v.paused) v.pause(); });
          Array.prototype.forEach.call(card.querySelectorAll('[data-glr-embed]'), (f) => { f.removeAttribute('src'); f.removeAttribute('data-glr-playing'); });
        }
      });
      const first = this.cards.findIndex((c) => !c.hidden);
      this.track.scrollTo({ left: 0, behavior: 'auto' });
      this.measure();
      if (first > -1) this.sync(first);
    }
  }
  customElements.define('glr-community-reels', GlrCommunityReels);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glr-comparison"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('glr-comparison')) {
  class GlrComparison extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-glr-tab]'));
      if (!this.tabs.length || this.ready) return;
      if (!('IntersectionObserver' in window)) { this.init(); return; }
      this.io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { this.io.disconnect(); this.init(); }
      }, { rootMargin: '200px' });
      this.io.observe(this);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
    init() {
      this.ready = true;
      this.cells = Array.prototype.slice.call(this.querySelectorAll('[data-glr-alt]'));
      this.addEventListener('click', (e) => {
        const tab = e.target.closest('[data-glr-tab]');
        if (!tab || !this.contains(tab)) return;
        this.select(parseInt(tab.getAttribute('data-glr-tab'), 10), false);
      });
      this.addEventListener('keydown', (e) => {
        const tab = e.target.closest('[data-glr-tab]');
        if (!tab) return;
        const i = this.tabs.indexOf(tab);
        let next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % this.tabs.length;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + this.tabs.length) % this.tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = this.tabs.length - 1;
        if (next === null) return;
        e.preventDefault();
        this.select(next, true);
      });
    }
    select(index, focus) {
      this.tabs.forEach((t, n) => {
        const on = n === index;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (on && focus) t.focus();
      });
      this.cells.forEach((c) => {
        c.toggleAttribute('hidden', parseInt(c.getAttribute('data-glr-alt'), 10) !== index);
      });
    }
  }
  customElements.define('glr-comparison', GlrComparison);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glr-durability-test"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('glr-durability-test')) return;

  class GlrDurabilityTest extends HTMLElement {
    connectedCallback() {
      if (this._observed) return;
      this._observed = true;

      // Kein JS-Init vor Sichtbarkeit: erst aufbauen, wenn die Section im Viewport ist.
      if (!('IntersectionObserver' in window)) {
        this._setup();
        return;
      }
      var self = this;
      this._io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            self._io.disconnect();
            self._io = null;
            self._setup();
            break;
          }
        }
      }, { rootMargin: '200px' });
      this._io.observe(this);
    }

    disconnectedCallback() {
      if (this._io) {
        this._io.disconnect();
        this._io = null;
      }
    }

    _setup() {
      if (this._ready) return;
      this.button = this.querySelector('[data-glr-dt-stone]');
      if (!this.button) return;
      this._ready = true;

      this.statusEl = this.querySelector('[data-glr-dt-status]');
      this.endEl = this.querySelector('[data-glr-dt-end]');
      this.max = Math.max(1, parseInt(this.dataset.clicks, 10) || 3);
      this.endText = this.dataset.endText || '';
      this.clicks = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.stages = [];
      var data = this.querySelector('[data-glr-dt-stages]');
      if (data) {
        try {
          this.stages = JSON.parse(data.textContent) || [];
        } catch (err) {
          this.stages = [];
        }
      }

      this._onClick = this._hit.bind(this);
      this.button.addEventListener('click', this._onClick);
    }

    _stageFor(n) {
      var best = null;
      for (var i = 0; i < this.stages.length; i++) {
        var s = this.stages[i];
        var at = parseInt(s.at, 10) || 0;
        if (n >= at && (best === null || at >= best.at)) best = { at: at, text: s.text };
      }
      return best;
    }

    _hit() {
      if (this.clicks >= this.max) return;
      this.clicks += 1;
      this.classList.add('is-tapped');

      if (!this.reduced) {
        var self = this;
        this.classList.remove('is-shake');
        // Reflow erzwingen, damit die Animation bei jedem Klick neu startet.
        void this.offsetWidth;
        this.classList.add('is-shake');
        window.setTimeout(function () {
          self.classList.remove('is-shake');
        }, 420);
      }

      var c1 = Math.max(1, Math.ceil(this.max / 3));
      var c2 = Math.max(c1 + 1, Math.ceil((this.max * 2) / 3));
      this.classList.toggle('is-crack-1', this.clicks >= c1);
      this.classList.toggle('is-crack-2', this.clicks >= c2);

      var done = this.clicks >= this.max;
      if (done) {
        // Pointe: der Stein bricht nicht.
        this.classList.add('is-held');
        this.button.setAttribute('aria-disabled', 'true');
        if (this.endEl) this.endEl.hidden = false;
        if (this.statusEl && this.endText) this.statusEl.textContent = this.endText;
        return;
      }

      var stage = this._stageFor(this.clicks);
      if (this.statusEl && stage && stage.text) this.statusEl.textContent = stage.text;
    }
  }

  customElements.define('glr-durability-test', GlrDurabilityTest);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glr-faq-search"] && !Shopify.designMode) return;
  try {
    
/* Clientseitige FAQ-Suche: filtert die .glr-faq-tabs-Eintraege live.
   Kein Server, kein Fetch — reine DOM-Filterung auf derselben Seite. */
(function () {
  function findTabs(root) {
    var targetId = root.getAttribute('data-glr-faq-target');
    var tabs = null;
    if (targetId) {
      var byId = document.getElementById(targetId);
      if (byId) tabs = byId.classList.contains('glr-faq-tabs') ? byId : byId.querySelector('.glr-faq-tabs');
    }
    if (!tabs) {
      var el = root.nextElementSibling;
      while (el && !tabs) {
        if (el.classList && el.classList.contains('glr-faq-tabs')) tabs = el;
        else if (el.querySelector) tabs = el.querySelector('.glr-faq-tabs');
        el = el.nextElementSibling;
      }
    }
    if (!tabs) tabs = document.querySelector('.glr-faq-tabs');
    return tabs;
  }

  function init(root) {
    if (root.__glrFaqSearch) return;
    root.__glrFaqSearch = true;

    var input = root.querySelector('[data-glr-faq-search-input]');
    var clearBtn = root.querySelector('[data-glr-faq-search-clear]');
    var countEl = root.querySelector('[data-glr-faq-search-count]');
    var emptyEl = root.querySelector('[data-glr-faq-search-empty]');
    var emptyTitle = root.querySelector('[data-glr-faq-search-empty-title]');
    if (!input) return;

    var tabs = findTabs(root);
    if (!tabs) return;

    var oneTpl = root.getAttribute('data-tpl-one') || '{count} answer for “{query}”';
    var manyTpl = root.getAttribute('data-tpl-many') || '{count} answers for “{query}”';
    var emptyTpl = root.getAttribute('data-tpl-empty') || 'No answers found.';

    function fill(tpl, count, query) {
      return tpl.split('{count}').join(count).split('{query}').join(query);
    }

    function restore() {
      tabs.removeAttribute('data-glr-faq-searching');
      var items = tabs.querySelectorAll('.glr-faq-tabs__item');
      for (var i = 0; i < items.length; i++) items[i].hidden = false;
      var panels = tabs.querySelectorAll('[data-glr-faq-panel]');
      var btns = tabs.querySelectorAll('[data-glr-faq-tab]');
      var active = 0;
      for (var j = 0; j < btns.length; j++) {
        if (btns[j].getAttribute('aria-selected') === 'true') { active = j; break; }
      }
      for (var k = 0; k < panels.length; k++) panels[k].hidden = (k !== active);
      if (countEl) { countEl.hidden = true; countEl.textContent = ''; }
      if (emptyEl) emptyEl.hidden = true;
      if (clearBtn) clearBtn.hidden = true;
    }

    function run() {
      var q = (input.value || '').trim();
      if (clearBtn) clearBtn.hidden = q.length === 0;
      if (!q) { restore(); return; }
      var ql = q.toLowerCase();
      tabs.setAttribute('data-glr-faq-searching', '');
      var panels = tabs.querySelectorAll('[data-glr-faq-panel]');
      var total = 0;
      for (var p = 0; p < panels.length; p++) {
        var items = panels[p].querySelectorAll('.glr-faq-tabs__item');
        var vis = 0;
        for (var i = 0; i < items.length; i++) {
          var match = (items[i].textContent || '').toLowerCase().indexOf(ql) !== -1;
          items[i].hidden = !match;
          if (match) vis++;
        }
        panels[p].hidden = vis === 0;
        total += vis;
      }
      if (countEl) {
        if (total > 0) { countEl.hidden = false; countEl.textContent = fill(total === 1 ? oneTpl : manyTpl, total, q); }
        else { countEl.hidden = true; }
      }
      if (emptyEl) {
        if (total === 0) { emptyEl.hidden = false; if (emptyTitle) emptyTitle.textContent = fill(emptyTpl, 0, q); }
        else { emptyEl.hidden = true; }
      }
    }

    input.addEventListener('input', run);
    input.addEventListener('search', run);
    if (clearBtn) clearBtn.addEventListener('click', function () {
      input.value = '';
      run();
      input.focus();
    });
  }

  function boot() {
    var els = document.querySelectorAll('[data-glr-faq-search]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glr-faq-tabs"] && !Shopify.designMode) return;
  try {
    
/* Chips-Picker (nur Darstellung "picker"): eine Pille aktiv, ihr Hinweis
   steht darunter. Ohne Picker gibt es das Element gar nicht. */
if (!customElements.get('glr-faq-chips')) {
  class GlrFaqChips extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.chips = Array.prototype.slice.call(this.querySelectorAll('[data-glr-chip]'));
      this.titleEl = this.querySelector('[data-glr-chip-title]');
      this.textEl = this.querySelector('[data-glr-chip-text]');
      this.badgeEl = this.querySelector('[data-glr-chip-badge]');
      if (!this.chips.length) return;
      this.select(0);
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-glr-chip]');
        if (!btn || !this.contains(btn)) return;
        this.select(this.chips.indexOf(btn));
      });
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const btn = e.target.closest('[data-glr-chip]');
        if (!btn) return;
        e.preventDefault();
        const n = (this.chips.indexOf(btn) + (e.key === 'ArrowRight' ? 1 : -1) + this.chips.length) % this.chips.length;
        this.select(n);
        this.chips[n].focus();
      });
    }
    select(i) {
      const chip = this.chips[i];
      if (!chip) return;
      this.chips.forEach((c, n) => {
        const on = n === i;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      if (this.titleEl) this.titleEl.textContent = chip.getAttribute('data-glr-chip-name') || '';
      if (this.textEl) this.textEl.textContent = chip.getAttribute('data-glr-chip-note') || '';
      /* Der Badge haengt an derselben Regel wie die Pillen-Farbe: ein Eintrag
         mit Hinweis gilt als bundle-abhaengig (--noted). */
      if (this.badgeEl) this.badgeEl.hidden = !chip.classList.contains('glr-faq-tabs__chip--noted');
    }
  }
  customElements.define('glr-faq-chips', GlrFaqChips);
}

(function () {
  function tabsOf(list) {
    return Array.prototype.slice.call(list.querySelectorAll('[data-glr-faq-tab]'));
  }

  function select(root, index, focus) {
    var list = root.querySelector('[data-glr-faq-tablist]');
    if (!list) return;
    var tabs = tabsOf(list);
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-glr-faq-panel]'));
    tabs.forEach(function (tab, i) {
      var on = i === index;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.setAttribute('tabindex', on ? '0' : '-1');
      if (panels[i]) panels[i].hidden = !on;
    });
    if (focus && tabs[index]) tabs[index].focus();
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-glr-faq-tab]');
    if (!tab) return;
    var root = tab.closest('.glr-faq-tabs');
    var list = tab.closest('[data-glr-faq-tablist]');
    if (!root || !list) return;
    select(root, tabsOf(list).indexOf(tab), false);
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('[data-glr-faq-tab]');
    if (!tab) return;
    var root = tab.closest('.glr-faq-tabs');
    var list = tab.closest('[data-glr-faq-tablist]');
    if (!root || !list) return;
    var tabs = tabsOf(list);
    var i = tabs.indexOf(tab);
    var next = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % tabs.length;
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = tabs.length - 1;
    if (next < 0) return;
    e.preventDefault();
    select(root, next, true);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glr-final-cta"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:product:select', function (e) {
  if (!(e.target instanceof Element) || e.target.closest('product-card')) return;
  if (!e.promise) return;
  e.promise.then(function (result) {
    var detail = result && result.detail; if (!detail) return;
    var v = detail.resource; if (!v) return;
    var pid = detail.productId != null ? String(detail.productId) : '';
    document.querySelectorAll('[data-glr-fcta-selection]').forEach(function (root) {
      if (pid && root.dataset.productId && root.dataset.productId !== pid) return;
      var el = root.querySelector('[data-glr-fcta-variant]');
      if (el && v.title) el.textContent = String(v.title).split(' / ').join(' \u00b7 ');
    });
    var src = (v.featured_image && v.featured_image.src) ? v.featured_image.src : ((v.image && v.image.src) ? v.image.src : '');
    if (src) {
      document.querySelectorAll('[data-glr-fcta-hero-img]').forEach(function (img) {
        if (pid && img.dataset.setProduct && img.dataset.setProduct !== pid) return;
        img.removeAttribute('srcset'); img.setAttribute('src', src);
      });
    }
  }).catch(function () {});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glr-in-use"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('glr-in-use')) {
  /* Wie viele Clips gleichzeitig gepuffert bleiben duerfen. Ohne Deckel haelt der Browser jedes
     einmal geladene Video im Speicher — bei sechs Karten laeuft das auf Mobilgeraeten voll und
     genau die aktive Karte ruckelt dann. Drei Karten sind immer geschuetzt (aktiv + Nachbarn),
     der vierte Platz ist die Reserve zum Verdraengen. */
  const WARM_MAX = 4;
  /* Touch-Geraete (iOS/Android): keine JS-Quell-Manipulation. cool()/warm() wuerden die inline
     <source> entfernen + load() aufrufen -> iOS zuendet danach kein autoplay mehr. Stattdessen
     bleiben die Quellen inline (preload="none" haelt es leicht) und iOS spielt das sichtbare Video
     nativ ab; off-screen wird nur pausiert. Das ist auf Mobil auch performanter. */
  const COARSE = !!(window.matchMedia && window.matchMedia('(hover: none)').matches);
  class GlrInUse extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-glr-track]');
      if (!this.track || this.ready) return;
      if (!('IntersectionObserver' in window)) { this.init(); return; }
      this.io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { this.io.disconnect(); this.init(); }
      }, { rootMargin: '600px' });
      this.io.observe(this);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); if (this.mio) this.mio.disconnect(); if (this.mql && this._mqlHandler) { if (this.mql.removeEventListener) this.mql.removeEventListener('change', this._mqlHandler); else if (this.mql.removeListener) this.mql.removeListener(this._mqlHandler); } }
    init() {
      this.ready = true;
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-glr-card]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-glr-dot]'));
      this.pills = Array.prototype.slice.call(this.querySelectorAll('.glr-in-use__pill'));
      this.cardBtns = Array.prototype.slice.call(this.querySelectorAll('[data-glr-card-btn]'));
      this.active = 0;
      this.track.addEventListener('scroll', () => {
        if (this.lock != null) return;
        window.cancelAnimationFrame(this.raf);
        this.raf = window.requestAnimationFrame(() => this.sync(this.nearest()));
      }, { passive: true });
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-glr-goto]');
        if (!btn || !this.contains(btn)) return;
        this.goTo(parseInt(btn.getAttribute('data-glr-goto'), 10));
      });
      this.track.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        this.goTo(this.active + (e.key === 'ArrowRight' ? 1 : -1));
      });
      this.sync(0);
      this.initMedia();
    }
    // Loop-Clips: abgespielt wird erst, wenn die Karte wirklich sichtbar ist. Der IO clippt die
    // Ziel-Rects an den Scroll-Containern der Vorfahren — horizontal weggescrollte Karten zaehlen
    // also nicht als sichtbar und pausieren. GELADEN wird dagegen deutlich frueher (siehe warm()),
    // sonst starrt man beim Aufscrollen erst auf das Poster.
    initMedia() {
      this.mql = window.matchMedia('(max-width:749px)');
      this.pickMedia();
      if (!this.cardMedia.some(Boolean)) return;
      this.captureClipSrc();
      this.warmOrder = [];
      this.mediaReady = true;

      // Viewport-Wechsel (Drehen/Resize): das nun sichtbare Element uebernehmen, das andere kalt
      // stellen — so bleibt es bei genau einem geladenen Video je Viewport.
      this._mqlHandler = () => this.rebuildMedia();
      if (this.mql.addEventListener) this.mql.addEventListener('change', this._mqlHandler);
      else if (this.mql.addListener) this.mql.addListener(this._mqlHandler);

      // Reduzierte Bewegung: Poster bleibt stehen. Auch das preload='metadata' aus dem Markup wird
      // wieder zurueckgenommen — kein Byte fuer etwas, das nie laufen wird.
      if (this.reduced()) { this.cardMedia.forEach((m) => this.cool(m)); return; }

      this.wireReady();

      // Vorabladen bei Annaeherung statt erst bei Sichtbarkeit: Zeigefinger/Fokus auf einer Karte
      // ist der frueheste ehrliche Hinweis, dass sie gleich dran ist.
      this.cards.forEach((card, i) => {
        const prime = () => this.warm(i);
        card.addEventListener('mouseenter', prime);
        card.addEventListener('touchstart', prime, { passive: true });
        card.addEventListener('focusin', prime);
      });

      this.warmAround(this.active);
      this.observeMedia();
    }
    // Je Karte das zum Viewport passende Medium waehlen. Ohne Mobil-Variante gibt es nur ein Element
    // — dann greift es unveraendert. Mit Mobil-Variante entscheidet data-glr-viewport (dt/m).
    pickMedia() {
      const want = (this.mql && this.mql.matches) ? 'm' : 'dt';
      this.cardMedia = this.cards.map((c) => {
        const list = Array.prototype.slice.call(c.querySelectorAll('[data-glr-clip],[data-glr-embed]'));
        if (!list.length) return null;
        if (list.length === 1) return list[0];
        let match = null;
        list.forEach((el) => { if (el.getAttribute('data-glr-viewport') === want) match = el; });
        return match || list[0];
      });
    }
    // Quell-URLs je Clip einmalig am Element sichern — ueberlebt cool() (entfernt die <source>-Knoten,
    // um Puffer freizugeben) und einen Viewport-Wechsel. warm() baut daraus die Quellen neu auf.
    captureClipSrc() {
      this.clipSrc = this.cardMedia.map((m) => {
        if (!m || m.tagName !== 'VIDEO') return null;
        if (!m._glrSources) {
          m._glrSources = Array.prototype.slice.call(m.querySelectorAll('source')).map((n) => ({ src: n.getAttribute('src'), type: n.getAttribute('type') }));
        }
        return m._glrSources;
      });
    }
    // Erst einblenden, wenn wirklich ein Bild da ist — sonst blitzt beim Umschalten ein leeres
    // Frame ueber dem Poster auf. Nur einmal je Element verdrahten.
    wireReady() {
      this.cardMedia.forEach((m) => {
        if (!m || m.tagName !== 'VIDEO' || m._glrReadyWired) return;
        m._glrReadyWired = true;
        const ready = () => { if (m.readyState >= 2) m.setAttribute('data-glr-ready', ''); };
        m.addEventListener('loadeddata', ready);
        m.addEventListener('canplay', ready);
        m.addEventListener('error', () => m.removeAttribute('data-glr-ready'));
        ready();
      });
    }
    observeMedia() {
      if (!('IntersectionObserver' in window)) { this.cardMedia.forEach((m) => { if (m) this.playMedia(m); }); return; }
      this.mio = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { this.playMedia(e.target); } else { this.pauseMedia(e.target); } });
      }, { threshold: 0.35 });
      this.cardMedia.forEach((m) => { if (m) this.mio.observe(m); });
    }
    // Viewport gewechselt: altes Set kaltstellen, neues Set anwaermen + beobachten.
    rebuildMedia() {
      if (!this.mediaReady) return;
      if (this.mio) { this.mio.disconnect(); this.mio = null; }
      this.cardMedia.forEach((el) => this.coolAny(el));
      this.warmOrder = [];
      this.pickMedia();
      this.captureClipSrc();
      if (this.reduced()) { this.cardMedia.forEach((m) => this.cool(m)); return; }
      this.wireReady();
      this.warmAround(this.active);
      this.observeMedia();
    }
    coolAny(el) {
      if (!el) return;
      if (el.tagName === 'VIDEO') { this.cool(el); return; }
      el.removeAttribute('src');
      el.removeAttribute('data-glr-playing');
    }
    // Aktive Karte + direkte Nachbarn aggressiv laden — in dieser Reihenfolge, damit die aktive
    // Karte bei einem vollen Cache zuletzt verdraengt wird.
    warmAround(i) { [i - 1, i + 1, i].forEach((n) => this.warm(n)); }
    // Diese drei duerfen nie verdraengt werden.
    keep() { return [this.active - 1, this.active, this.active + 1]; }
    warm(i) {
      if (COARSE) return; // Quellen bleiben inline; iOS laedt/spielt nativ
      if (!this.mediaReady || this.reduced()) return;
      const el = this.cardMedia[i];
      if (!el || el.tagName !== 'VIDEO') return;
      const pos = this.warmOrder.indexOf(i);
      if (pos > -1) this.warmOrder.splice(pos, 1);
      this.warmOrder.push(i);
      const sources = this.clipSrc[i] || [];
      if (!el.querySelector('source') && sources.length) {
        sources.forEach((n) => {
          const node = document.createElement('source');
          node.setAttribute('src', n.src);
          if (n.type) node.setAttribute('type', n.type);
          el.appendChild(node);
        });
        el.preload = 'auto';
        el.load();
      } else if (el.preload !== 'auto') {
        el.preload = 'auto';
        el.load();
      }
      this.trim();
    }
    trim() {
      while (this.warmOrder.length > WARM_MAX) {
        const keep = this.keep();
        const at = this.warmOrder.findIndex((n) => keep.indexOf(n) === -1);
        if (at === -1) return; // nur noch Geschuetztes uebrig
        this.cool(this.cardMedia[this.warmOrder.splice(at, 1)[0]]);
      }
    }
    cool(el) {
      if (!el || el.tagName !== 'VIDEO') return;
      if (COARSE) { el.pause(); return; } // Touch: nur pausieren, Quellen inline behalten (iOS-Autoplay)
      el.removeAttribute('data-glr-ready'); // blendet zurueck aufs Poster, kein Sprung auf Schwarz
      el.pause();
      el.preload = 'none';
      while (el.firstChild) el.removeChild(el.firstChild);
      el.removeAttribute('src');
      el.load();
    }
    playMedia(el) {
      if (el.tagName === 'VIDEO') {
        this.warm(this.cardMedia.indexOf(el));
        // iOS: muted + playsinline als PROPERTY setzen, sonst blockt Safari muted-Autoplay.
        el.muted = true;
        el.playsInline = true;
        el.setAttribute('muted', '');
        const tryPlay = () => { const pr = el.play(); if (pr && pr.catch) pr.catch(() => {}); };
        tryPlay();
        // Quelle wurde von warm() ggf. gerade erst gesetzt -> Video noch nicht abspielbar.
        // iOS ignoriert den ersten play(); beim Bereitsein erneut versuchen (einmalig).
        el.addEventListener('loadeddata', tryPlay, { once: true });
        el.addEventListener('canplay', tryPlay, { once: true });
        return;
      }
      if (el.getAttribute('src')) return;
      const type = el.getAttribute('data-glr-embed-type');
      const id = el.getAttribute('data-glr-embed-id');
      if (!id) return;
      el.setAttribute('src', type === 'vimeo'
        ? 'https://player.vimeo.com/video/' + id + '?background=1&autoplay=1&loop=1&muted=1&autopause=0&dnt=1'
        : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&mute=1&loop=1&playlist=' + id + '&controls=0&modestbranding=1&rel=0&playsinline=1&disablekb=1');
      el.setAttribute('data-glr-playing', '');
    }
    pauseMedia(el) {
      if (el.tagName === 'VIDEO' && !el.paused) el.pause();
    }
    reduced() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
    nearest() {
      const center = this.track.scrollLeft + this.track.clientWidth / 2;
      let best = 0, bd = Infinity;
      this.cards.forEach((c, i) => {
        const d = Math.abs(c.offsetLeft + c.clientWidth / 2 - center);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    goTo(i) {
      if (!this.cards.length) return;
      const idx = Math.max(0, Math.min(this.cards.length - 1, i));
      const card = this.cards[idx];
      const delta = (card.offsetLeft + card.clientWidth / 2) - (this.track.scrollLeft + this.track.clientWidth / 2);
      this.lock = idx;
      window.clearTimeout(this.lockT);
      this.lockT = window.setTimeout(() => { this.lock = null; }, 650);
      this.track.scrollTo({ left: this.track.scrollLeft + delta, behavior: this.reduced() ? 'auto' : 'smooth' });
      this.sync(idx);
    }
    sync(i) {
      this.active = i;
      this.cards.forEach((c, n) => { c.toggleAttribute('data-glr-active', n === i); });
      this.dots.forEach((d, n) => { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      this.pills.forEach((p, n) => { p.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
      this.cardBtns.forEach((b, n) => { b.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
      const total = this.cards.length || 1;
      this.style.setProperty('--glr-in-use-progress', (((i + 1) / total) * 100).toFixed(2) + '%');
      // Nachbarn der neuen aktiven Karte anwaermen (nach dem ersten sync(), initMedia() uebernimmt
      // den Start — deshalb die Guard).
      if (this.mediaReady) this.warmAround(i);
    }
  }
  customElements.define('glr-in-use', GlrInUse);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glr-pdp-anatomy"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-glr-anatomy-select]');
  if (!btn) return;
  var root = btn.closest('[data-glr-anatomy]');
  if (!root) return;
  var idx = btn.getAttribute('data-glr-anatomy-select');
  root.querySelectorAll('[data-glr-anatomy-select]').forEach(function (b) {
    var on = b.getAttribute('data-glr-anatomy-select') === idx;
    b.classList.toggle('is-active', on);
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
  });
  root.querySelectorAll('[data-glr-anatomy-panel]').forEach(function (p) {
    p.classList.toggle('is-active', p.getAttribute('data-glr-anatomy-panel') === idx);
  });
  (function () {
    var pm = root.querySelector('[data-glr-anatomy-partmap]');
    if (!pm) return;
    var pmap; try { pmap = JSON.parse(pm.textContent || '{}'); } catch (err) { return; }
    var pe = pmap[String(idx)];
    if (!pe) return;
    var pimg = root.querySelector('.glr-pdp-anatomy__img');
    if (!pimg) return;
    if (pe.srcset) { pimg.setAttribute('srcset', pe.srcset); } else { pimg.removeAttribute('srcset'); }
    if (pe.src) pimg.setAttribute('src', pe.src);
    if (pe.alt) pimg.setAttribute('alt', pe.alt);
  })();
});

// Variantenbindung: Anatomie-Bild bei Variantenwahl in der Buybox tauschen.
// shopify:product:select bubbelt bis zum document (bubbles:true) — die Section
// liegt ausserhalb der Buybox, daher hier global lauschen.
document.addEventListener('shopify:product:select', function (e) {
  // Events aus verschachtelten Produktkarten (z. B. Empfehlungen) ignorieren.
  if (!(e.target instanceof Element) || e.target.closest('product-card')) return;
  if (!e.promise) return;
  e.promise.then(function (result) {
    var detail = result && result.detail;
    if (!detail) return;
    var resource = detail.resource;
    var id = resource && resource.id;
    if (id == null) return;
    document.querySelectorAll('[data-glr-anatomy][data-glr-anatomy-bound="1"]').forEach(function (root) {
      if (detail.productId && root.dataset.productId && String(detail.productId) !== String(root.dataset.productId)) return;
      var s = root.querySelector('[data-glr-anatomy-imgmap]');
      if (!s) return;
      var map;
      try { map = JSON.parse(s.textContent || '{}'); } catch (err) { return; }
      var m = map[String(id)];
      if (!m) return;
      var img = root.querySelector('.glr-pdp-anatomy__img');
      if (!img) return;
      if (m.srcset) { img.setAttribute('srcset', m.srcset); } else { img.removeAttribute('srcset'); }
      if (m.src) img.setAttribute('src', m.src);
      if (m.alt) img.setAttribute('alt', m.alt);
    });
  }).catch(function () {});
});
(function () {
  document.querySelectorAll('[data-glr-anatomy]').forEach(function (root) {
    var pm = root.querySelector('[data-glr-anatomy-partmap]');
    if (!pm) return;
    var pmap; try { pmap = JSON.parse(pm.textContent || '{}'); } catch (err) { return; }
    var pe = pmap['0'];
    if (!pe) return;
    var img = root.querySelector('.glr-pdp-anatomy__img');
    if (!img) return;
    if (pe.srcset) { img.setAttribute('srcset', pe.srcset); } else { img.removeAttribute('srcset'); }
    if (pe.src) img.setAttribute('src', pe.src);
    if (pe.alt) img.setAttribute('alt', pe.alt);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glr-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('glr-reviews-rail')) {
  class GlrReviewsRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-glr-reviews-track]');
      if (!this.track || this.ready) return;
      // Init erst bei Sichtbarkeit: kein Scroll-Listener und kein Layout-Read fuer eine
      // Section, die der Besucher nie erreicht.
      if (!('IntersectionObserver' in window)) { this.init(); return; }
      this.io = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) { this.io.disconnect(); this.init(); }
      }, { rootMargin: '400px' });
      this.io.observe(this);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.mq && this.onMq) {
        if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMq);
        else if (this.mq.removeListener) this.mq.removeListener(this.onMq);
      }
    }
    init() {
      this.ready = true;
      this.cards = Array.prototype.slice.call(this.track.children);
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-glr-dot]'));
      this.active = 0;
      // Der Slider lebt ausschliesslich unter 750px — exakt die Grenze der CSS-Regel.
      // Oberhalb bleibt der Track ein normales Grid, deshalb bekommt er dort auch keine
      // Karussell-Semantik (sonst waere er ein toter Tab-Stopp auf dem Desktop).
      this.mq = window.matchMedia('(max-width:749px)');
      this.onMq = () => this.apply();
      if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
      else if (this.mq.addListener) this.mq.addListener(this.onMq);
      this.track.addEventListener('scroll', () => {
        if (!this.mq.matches || this.lock != null) return;
        window.cancelAnimationFrame(this.raf);
        this.raf = window.requestAnimationFrame(() => this.sync(this.nearest()));
      }, { passive: true });
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-glr-goto]');
        if (!btn || !this.contains(btn)) return;
        this.goTo(parseInt(btn.getAttribute('data-glr-goto'), 10));
      });
      this.track.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        this.goTo(this.active + (e.key === 'ArrowRight' ? 1 : -1));
      });
      this.apply();
    }
    apply() {
      const on = this.mq.matches;
      this.toggleAttribute('data-glr-ready', on);
      if (on) {
        const label = this.getAttribute('data-a11y-label') || '';
        this.track.setAttribute('tabindex', '0');
        this.track.setAttribute('role', 'group');
        this.track.setAttribute('aria-roledescription', label);
        this.track.setAttribute('aria-label', label);
        this.sync(this.nearest());
      } else {
        this.track.removeAttribute('tabindex');
        this.track.removeAttribute('role');
        this.track.removeAttribute('aria-roledescription');
        this.track.removeAttribute('aria-label');
        this.sync(0);
      }
    }
    reduced() {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }
    // Zielposition je Karte. Karte 0 liegt um das Bleed-Padding eingerueckt im Track — dank
    // scroll-padding rastet sie aber bei scrollLeft 0. Deshalb wird alles auf Karte 0 bezogen.
    targetFor(i) {
      if (!this.cards.length) return 0;
      return this.cards[i].offsetLeft - this.cards[0].offsetLeft;
    }
    nearest() {
      const x = this.track.scrollLeft;
      let best = 0, bd = Infinity;
      this.cards.forEach((c, i) => {
        const d = Math.abs(this.targetFor(i) - x);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    goTo(i) {
      if (!this.cards.length || !this.mq.matches) return;
      const idx = Math.max(0, Math.min(this.cards.length - 1, i));
      this.lock = idx;
      window.clearTimeout(this.lockT);
      this.lockT = window.setTimeout(() => { this.lock = null; }, 650);
      this.track.scrollTo({ left: this.targetFor(idx), behavior: this.reduced() ? 'auto' : 'smooth' });
      this.sync(idx);
    }
    sync(i) {
      this.active = i;
      this.dots.forEach((d, n) => { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
  }
  customElements.define('glr-reviews-rail', GlrReviewsRail);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glr-safety"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-glr-safety-prev],[data-glr-safety-next]');
  if (!btn) return;
  var root = btn.closest('.glr-safety');
  if (!root) return;
  var track = root.querySelector('[data-glr-safety-track]');
  if (!track) return;
  var card = track.querySelector('.glr-safety__card');
  var gap = 22;
  var step = card ? card.offsetWidth + gap : 340;
  var dir = btn.hasAttribute('data-glr-safety-next') ? 1 : -1;
  track.scrollBy({ left: dir * step, behavior: 'smooth' });
});

/* Punkte + Fortschrittsbalken. Gleiches Muster wie glr-usecases: erst bei
   Sichtkontakt initialisieren, damit die Section nichts kostet, solange sie
   weit unten steht. Ohne aktive Punkte-Navigation passiert hier nichts. */
if (!customElements.get('glr-safety')) {
  class GlrSafety extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-glr-safety-track]');
      if (!this.track || this.ready) return;
      this.watchFit();
      if (!this.querySelector('[data-glr-safety-dot]')) return;
      if (!('IntersectionObserver' in window)) { this.init(); return; }
      this.io = new IntersectionObserver((entries) => {
        if (entries.some((en) => en.isIntersecting)) { this.io.disconnect(); this.init(); }
      }, { rootMargin: '200px' });
      this.io.observe(this);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.ro) this.ro.disconnect();
    }
    /* Passen alle Karten nebeneinander, gibt es nichts zu sliden: Punkte,
       Fortschrittsbalken und Pfeile ausblenden (data-glr-fits). Prueft bei
       jeder Groessenaenderung neu, z. B. Desktop 3 Karten sichtbar, mobil nicht. */
    watchFit() {
      if (this.ro || this.fitBound) return;
      const check = () => {
        const fits = this.track.scrollWidth - this.track.clientWidth <= 2;
        this.toggleAttribute('data-glr-fits', fits);
      };
      check();
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(check);
        this.ro.observe(this.track);
      } else {
        this.fitBound = true;
        window.addEventListener('resize', check, { passive: true });
      }
    }
    init() {
      this.ready = true;
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-glr-safety-card]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-glr-safety-dot]'));
      this.active = 0;
      this.track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(this.raf);
        this.raf = window.requestAnimationFrame(() => this.sync());
      }, { passive: true });
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-glr-goto]');
        if (!btn || !this.contains(btn)) return;
        this.goTo(parseInt(btn.getAttribute('data-glr-goto'), 10));
      });
      this.track.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        this.goTo(this.active + (e.key === 'ArrowRight' ? 1 : -1));
      });
      this.sync();
    }
    maxScroll() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }
    nearest() {
      const max = this.maxScroll();
      if (max > 0 && this.track.scrollLeft >= max - 2) return this.cards.length - 1;
      const left = this.track.scrollLeft;
      let best = 0, bd = Infinity;
      this.cards.forEach((c, i) => {
        const d = Math.abs(c.offsetLeft - this.track.offsetLeft - left);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    goTo(i) {
      if (!this.cards.length) return;
      const idx = Math.max(0, Math.min(this.cards.length - 1, i));
      const card = this.cards[idx];
      const delta = card.offsetLeft - this.track.offsetLeft - this.track.scrollLeft;
      this.track.scrollTo({ left: this.track.scrollLeft + delta, behavior: 'smooth' });
      this.setActive(idx);
    }
    sync() { this.setActive(this.nearest()); this.progress(); }
    setActive(i) {
      this.active = i;
      this.dots.forEach((d, n) => { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    progress() {
      const sw = this.track.scrollWidth || 1;
      const w = Math.min(100, (this.track.clientWidth / sw) * 100);
      const max = this.maxScroll();
      const ratio = max > 0 ? this.track.scrollLeft / max : 0;
      const x = w > 0 ? (ratio * (100 - w) * 100) / w : 0;
      this.style.setProperty('--glr-safety-progress-w', w.toFixed(2) + '%');
      this.style.setProperty('--glr-safety-progress-x', x.toFixed(2) + '%');
    }
  }
  customElements.define('glr-safety', GlrSafety);
}

/* Play-on-Visible fuer die optionalen Video-Punkte. Gleicher data-glr-clip-Hook wie glr-in-use,
   aber eigenstaendig: startet den sichtbaren Clip, pausiert ihn beim Verlassen. Der jeweils
   ausgeblendete Viewport-Clip (display:none) hat keine Box und loest den Observer nie aus. */
(function () {
  if (window.__glrSafetyClipIO) return;
  window.__glrSafetyClipIO = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function setup() {
    var vids = document.querySelectorAll('.glr-safety [data-glr-clip]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      if (!reduce) Array.prototype.forEach.call(vids, play);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting && !reduce) play(en.target);
        else en.target.pause();
      });
    }, { threshold: 0.25 });
    Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
  }
  if (document.readyState !== 'loading') setup();
  else document.addEventListener('DOMContentLoaded', setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glr-scent-picker"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('glr-scent-picker')) {
  class GlrScentPicker extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-glr-sp-select]'));
      this.caption = this.querySelector('[data-glr-sp-caption]');
      this.frame = this.querySelector('[data-glr-sp-frame]');
      this.map = null;
      this.productId = this.dataset.productId || '';

      // Variantenbindung: auf die Variantenwahl der Buybox hören. Der
      // shopify:product:select-Event bubbelt bis zum document (bubbles:true),
      // deshalb hier global lauschen (die Section liegt AUSSERHALB der Buybox).
      if (this.dataset.glrSpBound === '1') {
        this._onSelect = (e) => this.onProductSelect(e);
        document.addEventListener('shopify:product:select', this._onSelect);
      }

      if (!this.tabs.length) return;
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-glr-sp-select]');
        if (!btn || !this.contains(btn)) return;
        this.select(parseInt(btn.getAttribute('data-glr-sp-select'), 10));
      });
      this.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
        const btn = e.target.closest('[data-glr-sp-select]');
        if (!btn) return;
        e.preventDefault();
        const i = this.tabs.indexOf(btn);
        const n = (i + (e.key === 'ArrowDown' ? 1 : -1) + this.tabs.length) % this.tabs.length;
        this.select(n);
        this.tabs[n].focus();
      });
    }
    disconnectedCallback() {
      if (this._onSelect) document.removeEventListener('shopify:product:select', this._onSelect);
    }
    getMap() {
      if (this.map) return this.map;
      const s = this.querySelector('[data-glr-sp-map]');
      try {
        const parsed = JSON.parse((s && s.textContent) || '{}');
        this.map = parsed && typeof parsed === 'object' ? parsed : {};
      } catch (err) { this.map = {}; }
      return this.map;
    }
    swapImg(url, alt) {
      if (!this.frame || !url) return;
      if (this.frame.getAttribute('src') === url) return;
      this.frame.removeAttribute('srcset');
      this.frame.setAttribute('src', url);
      if (alt) this.frame.setAttribute('alt', alt);
    }
    select(i) {
      this.tabs.forEach((t, n) => {
        const on = n === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      const t = this.tabs[i];
      if (this.caption && t) {
        this.caption.textContent = t.getAttribute('data-glr-sp-name') || '';
      }
      // Klick-getriebener Bildwechsel aus dem Bild der aktiven Karte.
      if (t) {
        const img = t.getAttribute('data-glr-sp-img');
        if (img) this.swapImg(img, t.getAttribute('data-glr-sp-alt'));
      }
    }
    onProductSelect(event) {
      // Events aus verschachtelten Produktkarten (z. B. Empfehlungen) ignorieren.
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      if (!event.promise) return;
      event.promise.then((result) => {
        const detail = result && result.detail;
        if (!detail) return;
        if (detail.productId && this.productId && String(detail.productId) !== String(this.productId)) return;
        const resource = detail.resource;
        const id = resource && resource.id;
        if (id == null) return;
        const m = this.getMap()[String(id)];
        if (!m) return;
        if (typeof m.i === 'number' && m.i >= 0 && this.tabs[m.i]) this.select(m.i);
        // Bevorzugt das serverseitig aufgelöste Bild (kann ein Metafeld sein,
        // das vom Karten-Bild abweicht) -> nach select() erneut setzen.
        if (m.img) this.swapImg(m.img, m.alt);
      }).catch(() => {});
    }
  }
  customElements.define('glr-scent-picker', GlrScentPicker);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glr-usecases"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-glr-uses-prev],[data-glr-uses-next]');
  if (!btn) return;
  var root = btn.closest('.glr-usecases');
  if (!root) return;
  var track = root.querySelector('[data-glr-uses-track]');
  if (!track) return;
  var card = track.querySelector('.glr-usecases__card');
  var step = card ? card.offsetWidth + 20 : 320;
  var dir = btn.hasAttribute('data-glr-uses-next') ? 1 : -1;
  track.scrollBy({ left: dir * step, behavior: 'smooth' });
});

if (!customElements.get('glr-usecases')) {
  class GlrUsecases extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-glr-uses-track]');
      if (!this.track || this.ready) return;
      if (!('IntersectionObserver' in window)) { this.init(); return; }
      this.io = new IntersectionObserver((entries) => {
        if (entries.some((en) => en.isIntersecting)) { this.io.disconnect(); this.init(); }
      }, { rootMargin: '200px' });
      this.io.observe(this);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
    init() {
      this.ready = true;
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-glr-uses-card]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-glr-uses-dot]'));
      this.active = 0;
      this.track.addEventListener('scroll', () => {
        window.cancelAnimationFrame(this.raf);
        this.raf = window.requestAnimationFrame(() => this.sync());
      }, { passive: true });
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-glr-goto]');
        if (!btn || !this.contains(btn)) return;
        this.goTo(parseInt(btn.getAttribute('data-glr-goto'), 10));
      });
      this.track.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        this.goTo(this.active + (e.key === 'ArrowRight' ? 1 : -1));
      });
      this.sync();
    }
    maxScroll() { return Math.max(0, this.track.scrollWidth - this.track.clientWidth); }
    nearest() {
      const max = this.maxScroll();
      if (max > 0 && this.track.scrollLeft >= max - 2) return this.cards.length - 1;
      const left = this.track.scrollLeft;
      let best = 0, bd = Infinity;
      this.cards.forEach((c, i) => {
        const d = Math.abs(c.offsetLeft - this.track.offsetLeft - left);
        if (d < bd) { bd = d; best = i; }
      });
      return best;
    }
    goTo(i) {
      if (!this.cards.length) return;
      const idx = Math.max(0, Math.min(this.cards.length - 1, i));
      const card = this.cards[idx];
      const delta = card.offsetLeft - this.track.offsetLeft - this.track.scrollLeft;
      this.track.scrollTo({ left: this.track.scrollLeft + delta, behavior: 'smooth' });
      this.setActive(idx);
    }
    sync() { this.setActive(this.nearest()); this.progress(); }
    setActive(i) {
      this.active = i;
      this.dots.forEach((d, n) => { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
    }
    progress() {
      const sw = this.track.scrollWidth || 1;
      const w = Math.min(100, (this.track.clientWidth / sw) * 100);
      const max = this.maxScroll();
      const ratio = max > 0 ? this.track.scrollLeft / max : 0;
      const x = w > 0 ? (ratio * (100 - w) * 100) / w : 0;
      this.style.setProperty('--glr-usecases-progress-w', w.toFixed(2) + '%');
      this.style.setProperty('--glr-usecases-progress-x', x.toFixed(2) + '%');
    }
  }
  customElements.define('glr-usecases', GlrUsecases);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glr-why-systems"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function panels(root) { return root.querySelectorAll('[data-glr-wsys-panel]'); }
  function tabs(root) { return root.querySelectorAll('[data-glr-wsys-tab]'); }

  /* ---------- Medien: nur das sichtbare System laden ---------- */
  function ready(el) { el.classList.add('is-ready'); }
  function hydrate(panel) {
    if (!panel || panel.dataset.glrWsysHydrated) return;
    panel.dataset.glrWsysHydrated = '1';
    var img = panel.querySelector('[data-glr-wsys-img]');
    if (img) {
      img.addEventListener('load', function () { ready(img); }, { once: true });
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
      if (img.complete && img.naturalWidth) ready(img);
    }
    var v = panel.querySelector('[data-glr-wsys-video]');
    if (v) {
      if (v.dataset.poster) {
        v.poster = v.dataset.poster;
        var pi = new Image(); pi.onload = function () { ready(v); }; pi.src = v.dataset.poster;
      }
      v.addEventListener('loadeddata', function () { ready(v); }, { once: true });
      if (!reduce) {
        v.querySelectorAll('source[data-src]').forEach(function (s) { s.src = s.dataset.src; s.removeAttribute('data-src'); });
        v.load();
      }
    }
  }
  function playActive(root) {
    var visible = root.dataset.glrWsysVisible === '1';
    panels(root).forEach(function (p) {
      var on = !p.hasAttribute('hidden');
      var v = p.querySelector('[data-glr-wsys-video]');
      if (on && visible) hydrate(p);
      if (!v) return;
      if (on && visible && !reduce) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      else if (!v.paused) v.pause();
    });
  }
  function observe(root) {
    if (root.dataset.glrWsysObserved) return;
    root.dataset.glrWsysObserved = '1';
    var visual = root.querySelector('[data-glr-wsys-visual]');
    if (!visual || !visual.querySelector('.glr-why-systems__media')) return;
    if (!('IntersectionObserver' in window)) { root.dataset.glrWsysVisible = '1'; playActive(root); return; }
    new IntersectionObserver(function (es) {
      es.forEach(function (en) { root.dataset.glrWsysVisible = en.isIntersecting ? '1' : '0'; playActive(root); });
    }, { rootMargin: '200px 0px' }).observe(visual);
  }
  function init() { document.querySelectorAll('.glr-why-systems').forEach(observe); }

  function select(root, index) {
    var t = tabs(root), p = panels(root);
    if (!t.length) return;
    if (index < 0) index = t.length - 1;
    if (index >= t.length) index = 0;
    for (var i = 0; i < t.length; i++) {
      var on = i === index;
      t[i].setAttribute('aria-selected', on ? 'true' : 'false');
      t[i].tabIndex = on ? 0 : -1;
      if (p[i]) { if (on) { p[i].removeAttribute('hidden'); } else { p[i].setAttribute('hidden', ''); } }
    }
    playActive(root);
    return t[index];
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-glr-wsys-tab]');
    if (!tab) return;
    var root = tab.closest('.glr-why-systems');
    if (!root) return;
    select(root, [].indexOf.call(tabs(root), tab));
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest('[data-glr-wsys-tab]');
    if (!tab) return;
    var root = tab.closest('.glr-why-systems');
    if (!root) return;
    var list = [].slice.call(tabs(root));
    var i = list.indexOf(tab);
    var next = -1;
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = i + 1;
    else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = i - 1;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = list.length - 1;
    else return;
    e.preventDefault();
    var el = select(root, next);
    if (el) el.focus();
  });

  /* Theme-Editor: neu geladene Section beobachten, gewähltes System zeigen */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target && e.target.closest && e.target.closest('[data-glr-wsys-tab]');
    if (!tab) return;
    var root = tab.closest('.glr-why-systems');
    if (root) select(root, [].indexOf.call(tabs(root), tab));
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
